import { NavLink, Routes, Route, Link } from "react-router-dom";
import { LayoutDashboard, Film, Download, Video, Rows3, Flag, Users, Settings, FileText, Inbox, ScrollText, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Overview, Videos, Sections, Reports, UsersAdmin, SiteSettings, Pages, InboxAdmin, Logs } from "@/pages/admin/AdminMisc";
import { TitlesAdmin, ImportAdmin, TitleEditor } from "@/pages/admin/AdminTitles";

const LINKS = [["", "Overview", LayoutDashboard], ["titles", "Titles", Film], ["import", "TMDB Import", Download], ["videos", "Videos", Video],
  ["sections", "Homepage", Rows3], ["reports", "Moderation", Flag], ["users", "Users", Users], ["inbox", "Inbox", Inbox],
  ["pages", "Legal Pages", FileText], ["settings", "Settings", Settings], ["logs", "Audit & Sync", ScrollText]];

export default function Admin() {
  const { settings, user } = useAuth();
  return (
    <div className="min-h-screen lg:grid lg:grid-cols-[230px_1fr]" data-testid="admin-dashboard">
      <aside className="border-b border-white/5 bg-[#08080B] p-4 lg:sticky lg:top-0 lg:h-screen lg:border-b-0 lg:border-r">
        <div className="flex items-center gap-2">
          <img src={settings.logo_url} alt="" className="h-9 w-9 rounded-full" />
          <div><p className="font-display text-lg leading-none text-amber-400">Admin</p><p className="text-[11px] text-slate-500">@{user.username}</p></div>
        </div>
        <nav className="no-scrollbar mt-5 flex gap-1 overflow-x-auto lg:flex-col">
          {LINKS.map(([to, l, I]) => (
            <NavLink key={to} to={`/admin${to ? "/" + to : ""}`} end data-testid={`admin-nav-${to || "overview"}`}
              className={({ isActive }) => `flex shrink-0 items-center gap-2 rounded-lg px-3 py-2 text-sm ${isActive ? "bg-amber-400/10 text-amber-300" : "text-slate-400 hover:bg-white/5 hover:text-white"}`}>
              <I className="h-4 w-4" />{l}
            </NavLink>
          ))}
        </nav>
        <Link to="/" className="mt-6 hidden items-center gap-2 text-xs text-slate-500 hover:text-white lg:flex"><ArrowLeft className="h-3 w-3" />Back to site</Link>
      </aside>
      <section className="min-w-0 p-4 sm:p-8">
        <Routes>
          <Route index element={<Overview />} />
          <Route path="titles" element={<TitlesAdmin />} />
          <Route path="titles/new" element={<TitleEditor />} />
          <Route path="titles/:id" element={<TitleEditor />} />
          <Route path="import" element={<ImportAdmin />} />
          <Route path="videos" element={<Videos />} />
          <Route path="sections" element={<Sections />} />
          <Route path="reports" element={<Reports />} />
          <Route path="users" element={<UsersAdmin />} />
          <Route path="inbox" element={<InboxAdmin />} />
          <Route path="pages" element={<Pages />} />
          <Route path="settings" element={<SiteSettings />} />
          <Route path="logs" element={<Logs />} />
        </Routes>
      </section>
    </div>
  );
}

